import * as Yup from 'yup';

const schema = Yup.object().shape({
  titulo: Yup.string().required('O campo título é obrigatório.'),
  versao: Yup.string().required('O campo versão ajuda é obrigatório.'),
  texto: Yup.string().required('O campo conteúdo é obrigatório.'),
});

export { schema };
